<template>
  <div class="col-md-12">
    <div class="uc-form-group">
      <label :for="`diplomaUniversity_${diplomaKey}`">Universidad</label>
      <v-select
        :class="`uc-input-style w-icon-left`"
        :create-option="(diplomaUniversity) => ({ id: diplomaUniversity, name: diplomaUniversity })"
        :options="universitiesList"
        :reduce="(university) => university.id"
        @input="
          setFieldArray({
            field: `diplomas`,
            id: `diploma_${diplomaKey}`,
            value: {
              id: `university`,
              value: diplomaUniversity,
            },
          })
        "
        :id="`diplomaUniversity_${diplomaKey}`"
        label="name"
        placeholder="Universidad"
        push-tags
        taggable
        v-model="diplomaUniversity"
        v-tooltip="
          `Si tu universidad no está en el listado, sólo ecríbela y presiona enter`
        "
      >
        <span slot="no-options">Búsqueda no encontrada...</span>
      </v-select>
      <i class="uc-icon">school</i>
    </div>

    <div class="uc-form-group">
      <label :for="`diplomaName_${diplomaKey}`">Nombre</label>
      <input
        v-model="diplomaName"
        :id="`diplomaName_${diplomaKey}`"
        @change="
          setFieldArray({
            field: `diplomas`,
            id: `diploma_${diplomaKey}`,
            value: {
              id: `name`,
              value: diplomaName,
            },
          })
        "
        type="text"
        :class="`uc-input-style w-icon-left`"
        placeholder="Nombre"
      />
      <i class="uc-icon">account_box</i>
    </div>

    <div class="uc-form-group">
      <label :for="`diplomaYear_${diplomaKey}`">Año Término</label>
      <v-select
        :class="`uc-input-style w-icon-left`"
        :options="years"
        :reduce="(year) => year.id"
        @input="
          setFieldArray({
            field: `diplomas`,
            id: `diploma_${diplomaKey}`,
            value: {
              id: `year`,
              value: diplomaYear,
            },
          })
        "
        :id="`diplomaYear_${diplomaKey}`"
        label="year"
        placeholder="Seleccione..."
        v-model="diplomaYear"
      >
        <span slot="no-options">Búsqueda no encontrada...</span>
      </v-select>
      <i class="uc-icon">school</i>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapMutations } from "vuex";
import { utils } from "@/mixins/utils.js";

export default {
  components: { "v-select": vSelect },
  mixins: [utils],
  props: {
    diplomaKey: { type: Number, default: 0 },
    universitiesList: Array,
    diplomaContent: Array,
  },
  data() {
    return {
      diplomaDate: [],
      diplomaDatePlaceholder: "Desde - Hasta",
      diplomaName: null,
      diplomaUniversity: null,
      diplomaYear: null,
      years: [],
    };
  },
  created() {
    for (var i in this.diplomaContent) {
      const element = this.diplomaContent[i];
      this[`diploma${this.capitalize(element.id)}`] = element.value;
    }
    this.years = this.fillYears();
  },
  methods: {
    ...mapMutations("CVForm", ["setFieldArray"]),

    fillYears() {
      const years = [];
      const currentYear = new Date().getFullYear();

      for (let i = 0; i < 45; i++) {
        years.push({
          id: currentYear - i,
          year: currentYear - i,
        });
      }

      return years;
    },
  },
  watch: {
    diplomaDate() {
      switch (this.diplomaDate.length) {
        case 1:
          this.diplomaDatePlaceholder = `Desde ${moment(
            this.diplomaDate[0] + "-01"
          ).format("MMM/Y")} - Actualidad`;
          break;
        case 2:
          this.diplomaDatePlaceholder = `Desde ${moment(
            this.diplomaDate[0] + "-01"
          ).format("MMM/Y")} - Hasta ${moment(
            this.diplomaDate[1] + "-01"
          ).format("MMM/Y")}`;
          break;
        default:
          this.diplomaDatePlaceholder = null;
      }
    },
  },
};
</script>
